// eslint-disable-next-line import/prefer-default-export
export function tryParse(str) {
  if (typeof str !== 'string') {
    return str;
  }
  try {
    return JSON.parse(str);
  } catch (err) {
    return {};
  }
}
